<template>
  <div v-if="isLoaded">
    <div class="content-body">
      <b-modal
        id="modal_form"
        ref="modal_form"
        :title="modal_titulo"
        :ok-title="modal_botao"
        close-title="Fechar"
        cancel-title="Cancelar"
        :ok-disabled="form.errors.any()"
        v-model="showModal"
        @ok="handleOk"
      >
        <form
          @submit.stop.prevent="handleOk"
          @keydown="form.errors.clear($event.target.name)"
        >
          <label>Nome da Equivalência</label>
          <b-form-input
            type="text"
            placeholder="Nome da Equivalência"
            v-model="form.nome"
            name="nome"
          >
          </b-form-input>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('nome')"
            v-if="form.errors.has('nome')"
          ></b-form-feedback>
          <label>Status</label>
          <b-form-group>
            <b-form-radio-group
              v-model="form.status"
              :options="optionsLivStatus"
              name="status"
              stacked
              plain
            ></b-form-radio-group>
          </b-form-group>
          <b-form-feedback
            v-text="form.errors.get('status')"
            v-if="form.errors.has('status')"
          ></b-form-feedback>
        </form>
        <div slot="modal-footer" class="w-100">
          <div class="float-left">
            <spinner v-if="loading" message="Processando..."></spinner>
          </div>
          <div class="float-right">
            <b-btn @click="showModal = false" variant="secondary">
              Fechar
            </b-btn>
            <b-btn
              @click="handleOk($event)"
              variant="primary"
              :disabled="isDisabled"
            >
              Enviar
            </b-btn>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import AvisoErros from "../components/AvisoErros";

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalCep: false,
      isFullscreen: false,
      ufSelected: [],
      optionsLivStatus: [],
      errors_array: [],
      form: new Form({
        nome: "",
        status: "",
        municipio_id: "",
        municipioequi_id: "",
      }),
      helpForm: new Form({ statusRecord: [], params: [] }),
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
  },
  mounted() {
    this.getLivGeral();
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.municipioequi_id);
      }
    },
    onCreate(data) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.form.municipio_id = data.municipio_id;
      this.errors_array = "";
      this.errors_array = [];
      this.form.status = 1;
      this.$refs.modal_form.show();
    },
    onEdit(data) {
      console.log(data);
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.form.municipio_id = data.municipio_id;
      this.form.status = data.status.valor;
      this.form.nome = data.nome;
      this.form.municipioequi_id = data.municipioequi_id;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .put("/api/municipio/equivalente/store")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .patch("/api/municipio/equivalente/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/municipio/equivalente/status")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/municipio/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.status_mun_equi.forEach((obj) => {
            this.optionsLivStatus.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
